import PropTypes from 'prop-types';
import packageItem from './package';

export default PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  packages: PropTypes.arrayOf(packageItem),
});
